import loggedInUser from "./loggedInUser";
import redirectAfterLogin from "./redirectAfterLogin";
import theme from "./theme";
import isLoading from "./isLoading";

export const rootReducers = { loggedInUser, redirectAfterLogin, theme, isLoading }

// export default combineReducers({ loggedInUser, redirectAfterLogin, theme, isLoading });